import { useQuery } from "@tanstack/react-query";
import businessCustomerService from "../../services/businessCustomer/businessCustomer.service";

// 0016: the SINGLE fetch of the agent-scoped customer list (/BusinessCustomer/ForAgent —
// assignment-filtered server-side; the agent select page + the add-customer dialog in agent
// context). Separate queryKey from the admin /List because it is a different (slimmer) payload.
// React Query dedups consumers + StrictMode to ONE call. Read-only → staleTime 5min.
const useCustomersForAgentQuery = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: ["businessCustomers", "forAgent"],
    queryFn: () => businessCustomerService.getCustomersForAgent().then((r) => r.data.payload),
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

export default useCustomersForAgentQuery;
